/**
 * Auth utility functions.
 * This file exists to break circular dependencies in auth-related slices.
 */

import { type DefaultRootState } from 'react-redux';
import {
  authStatusFromQuery,
  type AuthStatus,
} from '@bbkAdminRedux/rtkq/auth-status';
import { bbkApiSlice } from '@bbkAdminRedux/rtkq/bbkApi.slice';

/**
 * The single source of truth for auth status, derived from the
 * `/api/current_user` probe state (the server's authority on the session) via
 * the pure {@link authStatusFromQuery} mapper — not from reading a JS-visible
 * JWT cookie. The cookie is moving to a backend-managed, HttpOnly credential,
 * so it must not be a client-side signal.
 *
 * Consume this reactively via `useSelector(selectAuthStatus)` (or from the
 * request-guard's `api.getState()`); there is intentionally no imperative
 * `window.bbkStore`-based wrapper.
 */
export const selectAuthStatus = (state: DefaultRootState): AuthStatus =>
  authStatusFromQuery(bbkApiSlice.endpoints.getCurrentUser.select()(state));
